import { type Timestamp, timestampDate } from '@bufbuild/protobuf/wkt'

import { formatDateTimeFull } from '~/models/dateTime'

/**
 * proto Timestamp を表示用の日時文字列（yyyy/MM/dd HH:mm）に変換する。
 *
 * ProcurementPlanDetail の同名 helper と等価（page-local に複製。ページ間の
 * import 結合を避けるため共有モジュール化はしない）。
 *
 * @param ts - proto Timestamp（optional）
 * @param fallback - ts が undefined のときの表示文字列（デフォルト "—"）
 */
export function formatTimestamp(
  ts: Timestamp | undefined,
  fallback = '—',
): string {
  if (!ts) return fallback
  return formatDateTimeFull(timestampDate(ts))
}
